module.exports = __webpack_public_path__ + "img/image9.5491ae4e.jpeg";